import styled from 'styled-components'
import {WhiteContainer, fontTitle, fontPrices} from '../../theme/theme'
import { 
    ProductListContainer, 
    ProductImage, 
    DeleteProduct, 
    LoadContainer, 
    DiscountInCart } from '../../components/ShoppingCart/style'



export const SummaryLoadContainer = styled(LoadContainer)`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 20vh;
    width: 100%;
`


export const CartBody = styled.div`
    display: flex;    
    justify-content: center;

    
`
export const CartSection = styled.div`
    display: flex;    
    flex-direction: column;
`
export const CartContainer = styled(WhiteContainer)`
    display: flex;    
    height: auto;
    margin: 2em 1em;
`

export const SummaryDetailList = styled.div`
    display: flex;    
    height: auto;
    padding: 1em;
    width: 100vh;
    flex-direction: column;

    .counter-products{
        margin-left: 20px;
        margin-top: 20px; 
        color: rgba(153, 153, 153, 1);

    }
    
    
`
export const SummaryContainer = styled(WhiteContainer)`
    display: flex;    
    align-items: center;
    justify-content: center;
    height: 5vh;
    margin: 2em 1em;
    flex: 0 0 auto;
    position: absolute;
    
    
`
export const EmptyCart = styled.div`
    display: flex;    
    flex-direction: column;
    justify-content: center;
    padding: 5em;
    font-family: ${fontTitle};
    align-items: center;
`

export const CartProductsContainer = styled.div`
    display: flex;    
    flex-direction: column;
    
`
export const SummaryProductListContainer = styled(ProductListContainer)`
    flex-direction: column;
    overflow-y: auto;
    max-height: 70vh;
    margin-left: 1em;
    &::-webkit-scrollbar{
        width: 5px;
        
    }
    &::-webkit-scrollbar-thumb {
        border-radius: 2.5px;
        background: #C4C4C4;
    }
    &::-webkit-scrollbar-track {
        border-radius: 2.5px;
        background: #F6F6F6;
    }
    @media (max-width: ${props => props.theme.breakpoints.lg}) {
        overflow-y: hidden;
        max-height: fit-content;
        margin-left:0em;
    }
` 
export const RowProductListContainer = styled(ProductListContainer)`
    width: 100%;
    padding-top: 1rem;
    padding-bottom: 0rem;
    border-bottom: 1px solid rgba(246, 246, 246, 1);
    display: flex;
    justify-content: space-evenly;

    .summary-product-row-header-titles {
	    display: flex;
	    justify-content: space-evenly;
	    width: 100%;
	    text-align: center;
    }

    &#product-row{
        border-bottom: 2px solid #D3D3D3;
        padding: 0.5rem 0 !important;
    }

    @media (max-width: ${props => props.theme.breakpoints.lg}) {
        position: relative;
        &:first-of-type{
            margin-top: 0px;
            padding: 0em;
        }
        &:nth-child(-n+1) {
            border-bottom: 0px;
        }
        
    }



` 

export const RowProductListContainerMini = styled(RowProductListContainer)`
        @media (max-width: ${props => props.theme.breakpoints.md}) {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center !important;
    }
`
export const SummaryProductImage = styled(ProductImage)`
    max-width: 100px !important;
    max-height:100px !important;




    & #summary-product-cart-img {
        display: flex;
         align-items: flex-start;

         img {
           height: auto;

         }
    }


    & #summary-product-image-header{
        width: 116px;
        visibility: hidden;
    }

    @media (max-width: ${props => props.theme.breakpoints.lg}) {
        img {
            width: 100%;
            height: 100%;
            border-radius: 10px;
            object-fit: cover;
        }
    }
    @media (max-width: ${props => props.theme.breakpoints.md}) {
       img { 
        width: 100%;
        height: 100%;
          object-fit: cover;
        }
     }
    cursor: pointer;
` 

export const SummaryProductImageMini = styled(SummaryProductImage)`
        @media (max-width: ${props => props.theme.breakpoints.md}) {
            max-width: 80px !important;
            max-height: 80px !important;
     }
`

type ThasDiscount = {
    hasDiscount: boolean
}

export const SummaryProductInfo = styled.div<ThasDiscount>`
    display: flex;
    justify-content: space-around;
    width: 100%;
    align-items: center;
    font-family: ${fontTitle};
    font-weight: 400;

    .summary-product-title, .summary-total-prices  {
        width: 25%;

        @media (max-width: ${props => props.theme.breakpoints.md}) {
            width: 100%;
         }
    }

    .summary-product-prices, .summary-product-normalPrice {
        display: flex;
        flex-direction: column;
        width: 25%;

        @media (max-width: ${props => props.theme.breakpoints.md}) {
            width: 100%;
         }
    }


    @media (min-width: ${props => props.theme.breakpoints.lg}) {
        text-align: center;
        > * {
            box-sizing: border-box;
        }
    }
    @media (min-width: ${props => props.theme.breakpoints.xs}) {
        /* width: 60%; */
    }
    .summary-product-title, .summary-product-qty-prices-container, .summary-product-total{
        display: flex;
        justify-content: center;
        font-family: 'Open Sans';
        font-style: normal;
        font-weight: 400;
        font-size: 16px;
        line-height: 20px;
        @media (max-width: ${props => props.theme.breakpoints.lg}) {
            justify-content: flex-start;
        }
        & p{
            margin : 1em;
            margin-bottom: 0.3rem;
            color: black !important;
        }
        & p.shipping-operator{
            margin : 0px !important;
            font-family: Open Sans;
            font-weight: 700;
        }
        & p.summary-product-subTitle{
            color: rgba(153, 153, 153, 1);
            font-family: ${fontTitle};
            font-size: 15px;
            font-weight: 400;   
            margin: 1rem;
            margin-bottom : 2.5em;
            text-align: left;
        }
        & p.summary-product-reference-title {
            margin-top: 0;
            margin-bottom: 1rem;
            font-family: ${fontPrices};
            color: #5C5B5C !important;
        }
        
    }

    

    .summary-product-qty-prices-container {
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        width: 50%;
        align-items: center;
    }
    
    .summary-product-discount, .summary-product-discount-mini, .summary-product-normalPrice, .summary-product-normalPrice-mini, .summary-product-total, .summary-product-total-mini{
        font-family: ${fontPrices};
        padding: 0.5rem 0;
        font-weight: 700;

        .hide-on-mobile {
            display: none;
        }

        @media (max-width: ${props => props.theme.breakpoints.md}) {
            .mobile-only {
                display: inline;
            }

            .mobile-width {
                display: flex;
                flex-direction: column;
            }

            #Mobile-price-canceled {
                font-size: 12px;
                margin-right: 0.5rem;
            }
         }
    }


    .summary-product-bothPrices{
        display: flex;
        flex-direction: column;
    }

    .summary-product-normalPrice-canceled {
    color: rgba(196, 196, 196, 1);
    font-size: 14px;
    text-decoration: line-through;
    font-family: ${fontPrices};

    @media (max-width: ${props => props.theme.breakpoints.md}) { 
        &.hide-on-mobile {
            display: none;
        }
    }
}


    @media (max-width: ${props => props.theme.breakpoints.lg}) {
        flex-direction: column;
        font-size: 16px;
        align-items: flex-start;
        margin-left: 1.5em;

        .summary-product-title{
            color: rgba(153, 153, 153, 1);
            & p {
                margin-bottom : 0px;
            }
        }

    @media (max-width: ${props => props.theme.breakpoints.md}) {      
        margin-left: 1em;

        .summary-product-title-text__container {
            display: flex;
            flex-direction: column;
            align-items: flex-start;

            p {
                margin: 0;
                margin-bottom: 0.2rem;
            }

            .shipping-operator__container{
                margin-bottom: 0.5rem;
            }
        }

        .summary-product-normalPrice-canceled {
            text-align: start;
    }
     }

        .summary-product-quantity {
            position: absolute;
            bottom: ${ props => props.hasDiscount ? '6em' : '6.75em'};
            right: 6em;
            color: rgba(196, 196, 196, 1);
            &:before{
                content: "x ";
                
            }
        }
    
        .summary-product-discount, .summary-product-normalPrice{
            font-size: 14px;
         }


        .summary-product-total {
            display: flex;
            font-size: 14px;
            flex-direction: column;  

            @media (max-width: ${props => props.theme.breakpoints.md}) {
                display: block;
             }

        }


    }   

    .discount-labels-product {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 0.5rem;
    }
;
` 
export const SummaryDeleteProduct = styled(DeleteProduct)`
    width: 5%;
    justify-content: center;
    margin: 0;

    img {
        cursor: pointer;
    }
    
    @media (max-width: ${props => props.theme.breakpoints.lg}) {
        top: 1.5em;
        right: 0em;
        margin: auto;
    }
    
` 
export const SummaryDiscountInCart = styled(DiscountInCart)``

export const TitleList = styled.div`
    display: flex;
    justify-content: space-around;
    align-items: center;
    text-align: center;
    width: 100%;
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    > * {
        box-sizing: border-box;
        width: 25%;
    }
    @media (max-width: ${props => props.theme.breakpoints.lg}) {
        display: none;    
    }
`

export const SummaryProductInfoMini = styled(SummaryProductInfo)`
    display: flex !important;
    flex-direction: row !important;
    justify-content: space-between !important;
    align-items: center !important;

    .summary-product-title-mini {
        text-align: center;
        margin: 0 1em;
        font-size: 14px;
    }
`



export const CartSidebarQuantityDot = styled.div`
position: absolute;
width: 24px;
height: 24px;
background-color: ${props => props.color};
color: #FFFFFF;
border-radius: 50%;
text-align: center;
left: -30px;
top: -8px;

`;


export const QuantityDot = styled.div`
position: absolute;
width: 24px;
height: 24px;
background-color: ${props => props.color};
color: #FFFFFF;
border-radius: 50%;
text-align: center;
left: 64px;
top: -8px;

@media (min-width: 992px) { 
  left: 86px;
}
`;


export const SummaryProductScrolledContainer = styled.div`
 @media (max-width: 64em) and (max-height: 48em) {
      //1024
    min-height:26vh;
    max-height:35vh;
    overflow:auto;
    }

  @media (min-width: 80em) {
      //1200px
    min-height:26vh;
    max-height:35vh;
    overflow:auto;
    }
      
  @media (min-width: 112.5em) {
      //1800px
    min-height:27vh;
    max-height:35vh;
    overflow:auto;
    }
`;


